import React from "react";
import ContactForm from "./ContactForm";

export default function Contact() {
  return (
    <div id="contact" class="h-screen relative">
      <div class="w-8/12 flex flex-col mx-auto">
        <div class="flex">
          <div class="w-6/12 h-[600px]">
            <img class="h-full" src={`${process.env.PUBLIC_URL}/images/contact.jpg`} alt=""></img>
          </div>
          <div class="w-6/12">
            <ContactForm></ContactForm>
          </div>
        </div>
      </div>
    </div>
  );
}
